export const CURRENCY_DICTIONARY = {
  NIS: "₪",
  EUR: "€",
  USD: "$"
};

export const SHOW_RATES = "SHOW_RATES";
export const ROOM_IMAGES = "ROOM_IMAGES";

// mapping object for all the needed values in searchdata object that comming from server and saving in sessionsstorage.
export const SEARCH_DATA_STORE_PARAMETERS_MAPPING = {
  paxList: "Pax",
  checkinDate: "CheckIn",
  checkoutDate: "CheckOut",
  promoCode: "PromoCode",
  selectedHotelID: "SelectedHotelID",
  selectedRegionID: "SelectedRegionID",
  selectedCityCode: "SelectedCityCode",
  selectedOption: "SelectedOption",
  lang: "Lang",
  isIE: "isIE"
};

export const PayPalApi =
  "https://www.paypal.com/en_US/i/btn/btn_xpressCheckout.gif";

export const daysOfWeek = [
  {
    shortKey: "ShortSunday",
    longKey: "LongSunday",
    name: "Sunday",
    shortName: "Sun"
  },
  {
    shortKey: "ShortMonday",
    longKey: "LongMonday",
    name: "Monday",
    shortName: "Mon"
  },
  {
    shortKey: "ShortTuesday",
    longKey: "LongTuesday",
    name: "Tuesday",
    shortName: "Tue"
  },
  {
    shortKey: "ShortWednesday",
    longKey: "LongWednesday",
    name: "Wednesday",
    shortName: "Wed"
  },
  {
    shortKey: "ShortThursday",
    longKey: "LongThursday",
    name: "Thursday",
    shortName: "Thu"
  },
  {
    shortKey: "ShortFriday",
    longKey: "LongFriday",
    name: "Friday",
    shortName: "Fri"
  },
  {
    shortKey: "ShortSaturday",
    longKey: "LongSaturday",
    name: "Saturday",
    shortName: "Sat"
  }
];

export const PlaceHolderLocation = [
  {
    component: "RegionResults",
    location: "HeaderBottom"
  },
  {
    component: "SearchResults",
    location: "HeaderBottom"
  },
  {
    component: "DealsResults",
    location: "HeaderBottom"
  },
  {
    component: "RoomData",
    location: "HeaderBottom"
  },
  {
    component: "RegistrationPage",
    location: "PageTop"
  },
  {
    component: "RegistrationPage",
    location: "SpecialRequestsTop"
  },
  {
    component: "RegistrationPage",
    location: "PaymentHeaderBottom"
  },
  {
    component: "ConfirmationPage",
    location: "Top"
  },
  {
    component: "ConfirmationPage",
    location: "Bottom"
  },
  {
    component: "Cart",
    location: "Bottom"
  }
];

export const CONFIRMATION_ANALYTICS_PHASE = "Confirmation";
export const REGION_RESULTS_ANALYTICS_PHASE = "RegionResults";
export const HOTEL_RESULTS_ANALYTICS_PHASE = "HotelResults";
export const ROOM_RESULTS_ANALYTICS_PHASE = "RoomResults";
export const REGISTRATION_ANALYTICS_PHASE = "Registration";
export const PAYMENT_ANALYTICS_PHASE = "Payment";
export const DEAL_RESULTS_ANALYTICS_PHASE = "DealResults";



// WEBPACK FOOTER //
// ./src/constants/general.js